import React from "react";
import './SignupFormSwedish.css';

interface SignupFormSwedishProps {
    formRef: React.RefObject<HTMLFormElement>;
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => Promise<void>;
    isLoading?: boolean;
}

const SignupFormSwedish: React.FC<SignupFormSwedishProps> = ({ formRef, handleSubmit, isLoading }) => {
    return (
        <div className="full-width">
            <form ref={formRef} onSubmit={handleSubmit} method="POST" action="https://murphysolution53049.activehosted.com/proc.php" id="_form_68_" className="_form _form_68 _inline-form  _dark" novalidate data-styles-version="5">
                <input type="hidden" name="u" value="68" />
                <input type="hidden" name="f" value="68" />
                <input type="hidden" name="s" />
                <input type="hidden" name="c" value="0" />
                <input type="hidden" name="m" value="0" />
                <input type="hidden" name="act" value="sub" />
                <input type="hidden" name="v" value="2" />
                <input type="hidden" name="or" value="597868c5b9bedff51ce8881f83ea4359" />
                <div className="_form-content">
                    <div className="_form_element _x39298015 _full_width " >
                        <label htmlFor="fullname" className="_form-label">
                            Namn*
                        </label>
                        <div className="_field-wrapper">
                            <input type="text" id="fullname" name="fullname" required />
                        </div>
                    </div>
                    <div className="_form_element _x89381322 _full_width " >
                        <label htmlFor="email" className="_form-label">
                            Email*
                        </label>
                        <div className="_field-wrapper">
                            <input type="text" id="email" name="email" required />
                        </div>
                    </div>
                    <div className="_form_element _x33735865 _full_width " >
                        <label htmlFor="field[5]" className="_form-label">
                            Organisation
                        </label>
                        <div className="_field-wrapper">
                            <input type="text" id="field[5]" name="field[5]" />
                        </div>
                    </div>
                    <div className="_form_element _x27794466 _full_width " >
                        <fieldset className="_form-fieldset">
                            <div className="_row">
                                <legend className="_form-label">
                                    GDPR
                                </legend>
                            </div>
                            <input data-autofill="false" type="hidden" id="field[24][]" name="field[24][]" value="~|" />
                            <div className="_row _checkbox-radio">
                                <input id="field_24Jag godkänner att jag vill ta emot kommunikation om Murphy Solution&#039;s produkter, erbjudanden, nyhetsbrev, event, uppdateringar etc." type="checkbox" name="field[24][]" value="Jag godkänner att jag vill ta emot kommunikation om Murphy Solution&#039;s produkter, erbjudanden, nyhetsbrev, event, uppdateringar etc." />
                                <span>
                                    <label htmlFor="field_24Jag godkänner att jag vill ta emot kommunikation om Murphy Solution&#039;s produkter, erbjudanden, nyhetsbrev, event, uppdateringar etc.">
                                        Jag godkänner att jag vill ta emot kommunikation om Murphy Solution&#039;s produkter, erbjudanden, nyhetsbrev, event, uppdateringar etc.
                                    </label>
                                </span>
                            </div>
                        </fieldset>
                    </div>
                    <div className="_button-wrapper _full_width">
                        {isLoading === true
                            ? <div className='btn-icon-container vertical-aligner horizontal-aligner'>
                                <div className="small-spinner" />
                            </div> :
                            <button id="_form_68_submit" className="_submit" type="submit">
                                Ta mig till - The Murphy Standard
                            </button>}
                    </div>
                    <div className="_clear-element">
                    </div>
                </div>
            </form>
        </div>

    );
}

export default SignupFormSwedish;

